import { Modal } from 'react-bootstrap';
import clsx from 'clsx';
import { KTSVG } from '../../../../../../_metronic/helpers';

type Props = {
    show: boolean;
    title?: string;
    links?: string[];
    onClose: () => void;
};

const SiAiLinksModal: React.FC<Props> = ({ show, title, links, onClose }) => {
    const isLoading = false;
    const sanitizedLinks = Array.from(
        new Set(
            (links ?? [])
                .map((link) => link?.trim())
                .filter((link): link is string => Boolean(link))
        )
    );

    return (
        <Modal
            id='si_ai_links_modal'
            aria-hidden='true'
            tabIndex={-1}
            dialogClassName='modal-dialog-centered mw-1000px h-auto'
            show={show}
        >
            <div className={clsx('container-xxl px-5', isLoading && 'overlay overlay-block')}>
                <div className='modal-body'>
                    <div className='overlay-wrapper'>
                        <div className='w-100 d-flex justify-content-between mt-5 mb-3'>
                            <div>
                                <h1 className='d-flex align-items-center text-dark fw-bolder fs-3 ms-md-12'>
                                    {title || 'Links'}
                                </h1>
                            </div>
                            <div className='btn btn-icon btn-sm btn-light-primary me-md-9' onClick={onClose}>
                                <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
                            </div>
                        </div>

                        {sanitizedLinks.length ? (
                            <div className='d-flex flex-column gap-3 px-md-12 pb-4'>
                                {sanitizedLinks.map((url) => (
                                    <div key={url} className='d-flex align-items-center gap-2'>
                                        <span className='bullet rounded-3px h-10px me-5 pe-3'></span>
                                        <a
                                            href={url}
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            className='text-break fw-semibold'
                                        >
                                            {url}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className='text-center px-md-12 pb-4 text-muted'>
                                No reference URLs available.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export { SiAiLinksModal };
